<template>
    <div class="row">        
        <div class="col-10">
            <div class="pb-2">
                <label
                    for=""
                    class="font-14 my-2"
                >
                    Margem externa

                    <span
                        class="ml-2"
                        v-b-tooltip.hover
                        data-toggle="tooltip"
                        data-placement="top"
                        title="
                            T = Topo,
                            D = Direita,
                            B = Baixo,
                            E = Esquerda
                        "
                    >
                        <i class="fas fa-info-circle"></i>
                    </span>
                </label>

                <div class="row align-items-center">
                    <div class="col-6 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-up mr-2 font-size-12 arrow-up"></i> T</span>

                        <input 
                            @input="validateMarginInputDesktop('top')"
                            v-model="margin.top"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_top"
                        >
                    </div>

                    <div class="col-6 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-right mr-2 font-size-12 arrow-right"></i> D</span>

                        <input
                            @input="validateMarginInputDesktop('right')"
                            v-model="margin.right"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_right"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-down mr-2 font-size-12 arrow-down"></i> B</span>

                        <input
                            @input="validateMarginInputDesktop('bottom')"
                            v-model="margin.bottom"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_bottom"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-left mr-2 font-size-12 arrow-left"></i> E</span>

                        <input
                            @input="validateMarginInputDesktop('left')"
                            v-model="margin.left"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_left"
                        >
                    </div>
                </div>
            </div>

            <div>
                <label
                    for=""
                    class="font-14 my-2"
                >
                    Margem externa no celular

                    <span
                        class="ml-2"
                        v-b-tooltip.hover
                        data-toggle="tooltip"
                        data-placement="top"
                        title="
                            T = Topo,
                            D = Direita,
                            B = Baixo,
                            E = Esquerda
                        "
                    >
                        <i class="fas fa-info-circle"></i>
                    </span>
                </label>

                <div class="row d-flex align-items-center">
                    <div class="col-6 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-up mr-2 font-size-12 arrow-up"></i> T</span>

                        <input
                            @input="validateMarginInputMobile('top')"
                            v-model="marginMobile.top"
                            :disabled="isLockMarginMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_top"
                        >
                    </div>

                    <div class="col-6 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-right mr-2 font-size-12 arrow-right"></i> D</span>

                        <input 
                            @input="validateMarginInputMobile('right')"
                            v-model="marginMobile.right"
                            :disabled="isLockMarginMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_right"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-down mr-2 font-size-12 arrow-down"></i> B</span>

                        <input
                            @input="validateMarginInputMobile('bottom')"
                            v-model="marginMobile.bottom"
                            :disabled="isLockMarginMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_bottom"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span class="d-flex align-items-center"><i class="fal fa-arrow-left mr-2 font-size-12 arrow-left"></i> E</span>

                        <input
                            @input="validateMarginInputMobile('left')"
                            v-model="marginMobile.left"
                            :disabled="isLockMarginMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="-9999"
                            max="9999"
                            id="margin_left"
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="col-2 d-flex justify-content-center align-items-center">
            <button id="deslock" v-if="isLockMarginMobile" @click="handlerUnlockMarginMobile">
                <i class="fal fa-lock font-14"></i>
            </button>

            <button id="lock" v-else @click="handlerLockMarginMobile">
                <i class="fal fa-lock-open font-14"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameMargin',
    data() {
        return {
            margin: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            },
            marginMobile: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            },
            isLockMarginMobile: true,
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    watch: {
        margin: {
            handler() {
                this.$emit('onChangeMargin', this.margin);

                if (this.isLockMarginMobile) {
                    this.marginMobile.left = this.margin.left / 4;
                    this.marginMobile.top = this.margin.top / 4;
                    this.marginMobile.right = this.margin.right / 4;
                    this.marginMobile.bottom = this.margin.bottom / 4;
                }

                this.$emit('onChangeMarginMobile', this.marginMobile);
            },
            deep: true
        },
        marginMobile: {
            handler() {
                this.$emit('onChangeMarginMobile', this.marginMobile);
            },
            deep: true
        }
    },
    methods: {
        handlerUnlockMarginMobile() {
            this.isLockMarginMobile = false;

            this.$emit('onChangeLockMarginMobile', this.isLockMarginMobile);
        },
        handlerLockMarginMobile() {
            this.isLockMarginMobile = true;

            this.$emit('onChangeLockMarginMobile', this.isLockMarginMobile);
        },
        validateMarginInputDesktop(position) {
            let marginValue;

            switch (position) {
                case 'top':
                    marginValue = this.margin.top;
                    break;
                case 'right':
                    marginValue = this.margin.right;
                    break;
                case 'bottom':
                    marginValue = this.margin.bottom;
                    break;
                case 'left':
                    marginValue = this.margin.left;
                    break;
                default:
                    break;
            }


            if (marginValue == null) {
                marginValue = 0;
            }

            if (marginValue > 9999) {
                marginValue = 9999;
            }

            if (marginValue < -9999) {
                marginValue = -9999;
            }

            switch (position) {
                case 'top':
                    this.margin.top = marginValue;
                    break;
                case 'right':
                    this.margin.right = marginValue;
                    break;
                case 'bottom':
                    this.margin.bottom = marginValue;
                    break;
                case 'left':
                    this.margin.left = marginValue;
                    break;
                default:
                    break;
            }
        },
        validateMarginInputMobile(position) {
            let marginValue;

            switch (position) {
                case 'top':
                    marginValue = this.marginMobile.top;
                    break;
                case 'right':
                    marginValue = this.marginMobile.right;
                    break;
                case 'bottom':
                    marginValue = this.marginMobile.bottom;
                    break;
                case 'left':
                    marginValue = this.marginMobile.left;
                    break;
                default:
                    break;
            }

            if (marginValue == null) {
                marginValue = 0;
            }

            if (marginValue > 999) {
                marginValue = 999;
            }

            if (marginValue < -999) {
                marginValue = -999;
            }

            switch (position) {
                case 'top':
                    this.marginMobile.top = marginValue;
                    break;
                case 'right':
                    this.marginMobile.right = marginValue;
                    break;
                case 'bottom':
                    this.marginMobile.bottom = marginValue;
                    break;
                case 'left':
                    this.marginMobile.left = marginValue;
                    break;
                default:
                    break;
            }
        },
    },
    created() {
        if (this.item.extra.margin != undefined) {
            this.margin.left = this.item.extra.margin.left != null ? this.item.extra.margin.left : 0;
            this.margin.top = this.item.extra.margin.top != null ? this.item.extra.margin.top : 0;
            this.margin.right = this.item.extra.margin.right != null ? this.item.extra.margin.right : 0;
            this.margin.bottom = this.item.extra.margin.bottom != null ? this.item.extra.margin.bottom : 0;
        }

        if (this.item.extra.margin_mobile != undefined) {
            this.marginMobile.left = this.item.extra.margin_mobile.left != null ? this.item.extra.margin_mobile.left : 0;
            this.marginMobile.top = this.item.extra.margin_mobile.top != null ? this.item.extra.margin_mobile.top : 0;
            this.marginMobile.right = this.item.extra.margin_mobile.right != null ? this.item.extra.margin_mobile.right : 0;
            this.marginMobile.bottom = this.item.extra.margin_mobile.bottom != null ? this.item.extra.margin_mobile.bottom : 0;
        }

        if (this.item.extra.margin_mobile_lock != undefined) {
            this.isLockMarginMobile = this.item.extra.margin_mobile_lock;
        }
    }
}
</script>

<style scoped>
.font-size-12 {
    font-size: 12px;
}

.arrow-right {
    border-left: 1px solid #000;
    padding-left: 3px;
}

.arrow-left {
    border-right: 1px solid #000;
    padding-right: 3px;
}

.arrow-up {
    border-bottom: 1px solid #000;
    padding-bottom: 3px;
}

.arrow-down {
    border-top: 1px solid #000;
    padding-top: 3px;
}

#deslock, #lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameMargin.vue